<template>
    <div id="unbxd-product-listing-container"></div>
</template>

<style lang="css">
    @import "@/assets/scss/components/home/_search.scss";
    #unbxd-product-listing-container:deep(a){
        color: #AD073D !important;
    }
</style>
